import React from "react";

function ShutdownBanner(props){
    return <div class="alert alert-danger shutdown-banner" role="alert">
      Maesh is ceasing operations for its payment services on Thursday, January 28, 2021 at 8PM. Read our announcement here
    </div>
}

export default ShutdownBanner